import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { ModuleType } from "@enums/ModuleType";

@Injectable()
export class PeriodService extends ApiDataService {
    constructor() {
        super("periods");
    }

    getByModule(module: ModuleType) {
        const url = `/${module}`;
        return this.get<ModuleType[]>(url);
    }

    store(module: ModuleType, model) {
        const url = `/${module}`;
        return this.post(model, url);
    }

    getPermissions() {
        const url = `/permissions`;
        return this.get<any>(url);
    }
}
